// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jf-1";
export var messageSideRight = "_jf-2";
export var subscribeToBackInStockBubbleContainer = "_jf-0";